import WalletItem from "./WalletItem";

export default WalletItem;
